import { supabase } from "./supabase";

// Resolve the app's public origin for auth-email redirect links. Uses
// REACT_APP_SITE_URL in production; falls back to the current origin in dev.
// NOTE: whatever this resolves to must ALSO be whitelisted in the Supabase
// dashboard's Redirect URLs — otherwise Supabase ignores redirectTo and bakes
// the project Site URL into the emailed link (which defaults to localhost:3000
// on new projects). See SETUP.md → Supabase Auth URL configuration.
function siteUrl(): string {
  return process.env.REACT_APP_SITE_URL || window.location.origin;
}

export async function signUp(email: string, password: string) {
  // emailRedirectTo makes the signup-confirmation email link point at the
  // configured origin instead of relying solely on the Supabase Site URL
  // (which is the localhost-link failure mode when the dashboard is unset).
  return supabase.auth.signUp({
    email,
    password,
    options: { emailRedirectTo: `${siteUrl()}/auth/callback` },
  });
}

export async function signIn(email: string, password: string) {
  return supabase.auth.signInWithPassword({ email, password });
}

export async function signOut() {
  return supabase.auth.signOut();
}

export async function getSession() {
  const { data } = await supabase.auth.getSession();
  return data.session;
}

export async function getAccessToken(): Promise<string | null> {
  const session = await getSession();
  return session?.access_token || null;
}

export async function resetPasswordForEmail(email: string) {
  // #2147 — a DEDICATED page, not the shared /auth/callback. The recovery
  // "set new password" step needs to know it's a recovery link, and that
  // signal (type=recovery in the hash) is destroyed by supabase-js at
  // bootstrap before a lazy component can read it. A dedicated path IS the
  // signal and can't be stripped. Must be covered by the Supabase Redirect
  // URLs allowlist (the existing https://parcelyapp.com/** wildcard covers it).
  return supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${siteUrl()}/reset-password`,
  });
}
